export enum SessionLinkType {
  Self = 'self',
  Hpp = 'hpp',
  SeamlessHpp = 'seamless_hpp',
  SubmitCard = 'submitCard',
  AjaxSubmitCard = 'ajaxSubmitCard',
}

export enum SessionLinkMethodType {
  Get = 'GET',
  Redirect = 'REDIRECT',
  FormPost = 'FORM_POST',
  AjaxPost = 'AJAX_POST',
}
